import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from '@mui/material';
import { setDialogOpen } from '../../store/Actions';
import { Account } from './AccountOptions/Account';
import { UploadAccountAvatar } from './UploadAvatar/UploadAccountAvatar';
import { EditFriend } from './AccountOptions/Friends/EditFriend';
import { UploadFriendAvatar } from './UploadAvatar/UploadFriendAvatar';
import { EditCategory } from './AccountOptions/Categories/EditCategory';
import { EditTrip } from './AccountOptions/Trips/EditTrip';
import { EditTag } from './AccountOptions/Tags/EditTag';
import { EditEvent } from './EditEvent';
import { ViewEvent } from './ViewEvent';

export function MyDialog() {
    const dialogOpen = useSelector(state=>state.dialogOpen);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setDialogOpen(false));
    };

    let dialogContent = null;
    let fullScreen = false;
    let height = '700px'
    let width = undefined;
    switch(dialogOpen) {
        case 'Edit Event':
            dialogContent = <EditEvent/>;
            // The reimagined Edit Event experience takes over the full viewport
            // so the form has room to breathe and side-by-side panels can fit.
            fullScreen = true;
            break;
        case 'View Event':
            dialogContent = <ViewEvent/>;
            fullScreen = true;
            break;
        case 'Account':
            dialogContent = <Account/>
            break;
        case 'Update Account Avatar':
            dialogContent = <UploadAccountAvatar/>
            break;
        case 'Edit Friend':
            dialogContent = <EditFriend/>
            break;
        case 'Edit Category':
            dialogContent = <EditCategory/>
            break;
        case 'Edit Trip':
            dialogContent = <EditTrip/>;
            // The reimagined Edit Trip dialog uses sticky top/bottom bars and
            // an internal scrolling body, so it needs a fixed Paper size for
            // the sticky positioning to anchor against. 640px is shorter than
            // EditEvent's 700px since Trips have far fewer fields.
            height = '640px';
            width = '480px';
            break;
        case 'Edit Tag':
            dialogContent = <EditTag/>
            break;
        case 'Update Friend Avatar':
            dialogContent = <UploadFriendAvatar/>
            break;
        default:
            dialogContent = null;
            break;
      }

    return (
        <Dialog
            onClose={handleClose}
            open={dialogOpen}
            fullScreen={fullScreen}
            maxWidth={false}
            PaperProps={{
                sx: {
                    maxWidth: fullScreen ? '100vw' : '90vw',
                    maxHeight: fullScreen ? '100dvh' : '90vh',
                    width: fullScreen ? '100vw' : width,
                    height: fullScreen ? '100dvh' : height,
                    overflow: 'hidden',
                    '@media (max-width: 600px)': {
                        width: fullScreen ? '100vw' : 'calc(100vw - 32px)',
                        height: fullScreen ? '100dvh' : (dialogOpen === 'Edit Event' ? 'calc(100dvh - 32px)' : undefined),
                        maxWidth: fullScreen ? '100vw' : 'calc(100vw - 32px)',
                        maxHeight: fullScreen ? '100dvh' : 'calc(100dvh - 32px)',
                        margin: fullScreen ? 0 : '16px',
                    },
                }
            }}
        >
            <div style={{width:'100%', height:'100%', display:'flex', flexDirection:'column', overflow:'auto'}}>
                {dialogContent}
            </div>
        </Dialog>
    );
}
